import { FleekError } from './FleekError';

type PinsNotFoundErrorOptions = {
  filename?: string;
};

export class PinsNotFoundError extends FleekError<PinsNotFoundErrorOptions> {
  public name = 'PinsNotFoundError';

  toString = () => {
    return 'No pins found.';
  };
}
